export enum Role {
  ABONNE = 'ROLE_ABONNE',
  CONSULTANT = 'ROLE_CONSULTANT',
  CONSULTANT_DEPRECATED = 'CONSULTANT'
}

export namespace Role {
  export function isConsultant(role: Role): boolean {
    return role === Role.CONSULTANT || role === Role.CONSULTANT_DEPRECATED;
  }
}
